import * as React from "react";

import { Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';

type category = {
  id: number;
  name: string
}
type CategoryProps = {
  categories?: category[];
}

const icons: { [key: number]: string } = {
  1: "/vitrin/icons/electronic.svg",
  2: "/vitrin/icons/poshak.svg",
  3: "/vitrin/icons/arayeshi.svg",
  4: "/vitrin/icons/varzeshi.svg",
  5: "/vitrin/icons/khodro.svg",
  6: "/vitrin/icons/ashpazkhane.svg",
}

const CategoriesSection = (props: CategoryProps) => {
  return (
    <div className='wrapper' >
      <h2 className='text-center'>دسته بندی‌ها</h2>
      <Grid container>
        {props.categories?.map((cat: category) => (<Grid container item lg={4} className="mb-3 text-center">
          <img src={icons[cat.id]} alt={cat.name} className="ml-2" />
          <Link to={`/vitrin/products?sort=created,desc&categoryId.equals=${cat.id}&size=20&page=0`} className="link">{cat.name}</Link>
        </Grid>))}
      </Grid>
    </div>
  )
}

export default CategoriesSection